/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component } from '@angular/core';
import { ItemService } from '../../item.service';
import { IItem, ITEM_TTL_ES } from '../../item.interface';
import { CrudTemplate } from 'src/app/@amiga-pyme/crud/templates/crud.template';
import { ICrudTemplate } from 'src/app/@amiga-pyme/crud/templates/crud.interface';

@Component({
  selector: 'pg-items',
  templateUrl: './item.component.html'
})
export class ItemComponent extends CrudTemplate implements ICrudTemplate {
  constructor(private serviceBase: ItemService) {
    super(ITEM_TTL_ES, serviceBase);
  }

  async ngOnInit() {
    this.table.settings = {
      title: ITEM_TTL_ES,
      columns: [
        { header: 'Código', field: 'code' },
        { header: 'Descripción', field: 'name' },
        { header: 'Principio Activo', field: 'activesIngredients' },
        { header: 'Grupo Terapéutico', field: 'therapistGroups' }
      ]
      //
    };
    this.initSubscriptions$();
  }

  initSubscriptions$() {
    this.suscriptionBase$ = this.serviceBase
      .getData$()
      .subscribe((data: IItem[]) => {
        this.table.data = data;
      });
  }

  ngOnDestroy() {
    this.unsubscribeBase();
  }
}
